import { gql } from '@apollo/client';

export const SAVE_CLIP_COVER = gql`
  mutation SaveClipCover($id: ID!, $data: JSON!) {
    updateClipData(id: $id, data: $data) {
      id
      cover_image_url
      dirty
    }
  }
`;

export type SaveClipCoverMutation = {
  __typename?: 'Mutation';
  updateClipData?: {
    __typename?: 'MyClip';
    id: string;
    cover_image_url?: string | null;
    dirty?: boolean | null;
  } | null;
};

export type SaveClipCoverMutationVariables = {
  id: string;
  data: unknown;
};
